import {
  DATOS_DEPARTAMENTOS,
  MAPA_CIUDADES_A_DEPARTAMENTOS,
} from '../../utilidades/geografia.static';
import { OpcionCampo } from './formulario.models';

/* Configuración del mapa para crear dirección */
export const CONFIGURACION_MAPA_FORMULARIO: google.maps.MapOptions = {
  mapTypeControl: false,
  fullscreenControl: false,
  streetViewControl: false,
  zoomControl: true,
  scaleControl: false,
  rotateControl: false,
  clickableIcons: false,
  draggableCursor: 'pointer',
};

/* Centro de Bogotá */
export const CENTRO_BOGOTA = { lat: 4.60971, lng: -74.08175 };

/* Opciones para campo tipo de identificación */
export const OPCIONES_TIPO_IDENTIFICACION_FORMULARIO: OpcionCampo<string>[] = [
  { valor: 'CC', nombre: 'Cédula de Ciudadanía' },
  { valor: 'CE', nombre: 'Cédula de Extranjería' },
  { valor: 'RC', nombre: 'Registro Civil' },
  { valor: 'TI', nombre: 'Tarjeta de Identidad' },
  { valor: 'PA', nombre: 'Pasaporte' },
  { valor: 'PE', nombre: 'Permiso especial de permanencia' },
  { valor: 'PT', nombre: 'Permiso temporal de permanencia' },
  { valor: 'NIT', nombre: 'NIT' },
  { valor: 'Otro', nombre: 'Otro' },
];

/* Opciones para campo departamento */
export const OPCIONES_DEPARTAMENTOS_FORMULARIO: OpcionCampo<string>[] = DATOS_DEPARTAMENTOS.map(
  (departamento) => ({
    valor: departamento.nombre,
    nombre: departamento.nombre,
    extra: departamento.codigo,
  }),
);

/* Opciones para campo ciudad */
export const OPCIONES_CIUDADES_FORMULARIO: OpcionCampo<string>[] = Object.keys(
  MAPA_CIUDADES_A_DEPARTAMENTOS,
).map((ciudad) => ({ valor: ciudad, nombre: ciudad }));
